
import { Component, Vue, Prop } from "vue-property-decorator"
import vSelect from "vue-select"
import api from "@/services/api"
import { Template } from "@/types/template"

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class TemplateSelect extends Vue {
	@Prop({ default: () => null })
	public value!: string | string[] | null

	@Prop({ default: false, type: Boolean })
	public multiple!: boolean

	private templates: Template[] = []
	private loading = true

	async mounted (): Promise<void> {
		try {
			this.templates = await api.categories()
		} catch (error) {
			console.error("Error loading templates:", error)
		} finally {
			this.loading = false
		}
	}

	private get selectedTemplate (): Template | Template[] | null {
		if (!this.value) {
			return null
		}

		if (this.multiple && Array.isArray(this.value)) {
			const valueArray = this.value as string[]
			return this.templates.filter(t => valueArray.includes(t.id!))
		}

		return this.templates.find(t => t.id === this.value) || null
	}

	private set selectedTemplate (value: Template | Template[] | null) {
		if (!value) {
			this.$emit("input", null)
			return
		}

		if (Array.isArray(value)) {
			this.$emit("input", value.map(t => t.id))
		} else {
			this.$emit("input", value.id)
		}
	}
}
